import React from 'react'

const BrandingIcon = ({color}) => {
  return (
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        height="20" 
        viewBox="0 -960 960 960" 
        width="20"
        fill={color}
    >
        <path d="M400-280h360v-240H400v240ZM160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm0-80h640v-480H160v480Zm0 0v-480 480Z"/>
    </svg>
  )
}

export default BrandingIcon